/* eslint-disable react/prop-types */
import { I18nModel } from '@bingads-webui-universal/i18n-model';
import core from '@bingads-webui-universal/i18n-cldr-data-modern/core.json';
import iana from 'iana-tz-data/iana-tz-data.json';

export function setupI18nModel(locale, I18nModelClass = I18nModel) {
  I18nModelClass.loadCLDRData(core);
  I18nModelClass.loadTimeZoneData(iana);
  I18nModelClass.setGlobalLocale(locale);

  // callback for webpack dynamic import
  return ({ default: data }) => {
    I18nModelClass.loadCLDRData(data);

    return null;
  };
}
